import app from 'flarum/common/app';
import { optionProviders } from './addFollowingPageOption';
const cache = {};
export default function followingPageOptions(section) {
  if (!cache[section]) {
    // Start with default options
    cache[section] = ['none', 'tags'].reduce((o, key) => {
      o[key] = app.translator.trans("fof-follow-tags.".concat(section, ".following_").concat(key, "_label"));
      return o;
    }, {});

    // Add options from other extensions
    optionProviders.forEach(provider => {
      Object.assign(cache[section], provider(section));
    });
  }
  return cache[section];
}
flarum.reg.add('fof-follow-tags', 'common/utils/followingPageOptions', followingPageOptions);